import React, { useState, useEffect, useRef } from 'react';
import RecentWithdrawalsList from './RecentWithdrawalsList';
import AppConfig from '../../AppConfig';
import { useAppData } from '../../redux/appDataProvider';
import ApiClient from '../../utilities/apiClient';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
const RecentWithdrawalsListController = ({ submitdata, fetchBalance }) => {

  const apiToken = useSelector(state => state.auth.apiToken);
  const { userInfo, setUserInfo } = useAppData();
  const { selectedYear, setSelectedYear } = useAppData();
  const [showlodder, setShowLodder] = React.useState(false);
  const [withdrawcancel, setWithdrawcancel] = React.useState(false);

  const [a, SetA] = useState();
  const [cuserrefno, SetCUserRefNo] = useState();
  const [camount, SetCAmount] = useState();
  const [recentWithdrawalsData, setRecentWithdrawalsData] = useState();
  // start, state values date - srini - 30-01-25
  const [fromDate, setFromDate] = useState(new Date().toLocaleDateString());
  const [toDate, setToDate] = useState(new Date().toLocaleDateString());
  const fromDateRef = useRef(fromDate);
  const toDateRef = useRef(toDate);
  // end - srini - 30-01-25
  const handleCancelClick = (refNo, txdate, amount) => {
    // Add logic to handle cancel action
    console.log(`Cancel clicked for Ref No: ${refNo}`);
    let tradedate = txdate.slice(0, 10).split("-").join("/")
    SetCUserRefNo(refNo)
    SetCAmount(amount)
    console.log(`Cancel clicked for Ref No: ${tradedate}`);

    setShowLodder(true)
    try {
      const apiClient = new ApiClient(apiToken);
      apiClient.fetchData(
        AppConfig.api.Withdraw.cancel,
        "POST",
        {
          "Client_Code": userInfo.CLIENT_ID,
          "Trade_Date": tradedate,
          "UserRefNo": refNo
        })
        .then((response) => {

          setShowLodder(false)


          if (response && response.Success == "False" && response.hasOwnProperty("Error Description")) {


          }
          if (response && response.Success == "True" && response.hasOwnProperty("Success Description")) {
            let responseData = response["Success Description"];
            setWithdrawcancel(true)
            fetchTxList();
            fetchBalance();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }

  };

  const getStatus = (status) => {

    return AppConfig.withdrawStatus[status] || "Unknown";
  };

  const fetchTxList = async () => {
    let tdate = dayjs(new Date()).format('DD/MM/YYYY')
    let tdate1 = dayjs(new Date()).format('YYYY-MM-DD')
    let fdate = dayjs(tdate1).subtract(3, 'month').format('DD/MM/YYYY')

    setShowLodder(true)
    try {
      const apiClient = new ApiClient(apiToken);
      apiClient.fetchData(
        AppConfig.api.Withdraw.list,
        "POST",
        {
          "FROM_DATE": fromDateRef.current, // srini - 30-01-25
          "TO_DATE": toDateRef.current, // srini - 30-01-25

          "CLIENT_ID": userInfo.CLIENT_ID ? userInfo.CLIENT_ID : localStorage.getItem("userid"),
          "TRANS_TYPE": "AP",
          "datayear": selectedYear.Database_Year ? selectedYear.Database_Year : localStorage.getItem("year")
        })
        .then((response) => {

          setShowLodder(false)


          if (response && response.Success == "False" && response.hasOwnProperty("Error Description")) {

            setRecentWithdrawalsData([]);
          }
          if (response && response.Success == "True" && response.hasOwnProperty("Success Description")) {
            let responseData = response["Success Description"];

            if (Array.isArray(responseData) && responseData.length > 0) {
              // sorting punch time value with time 18-07-24 Dev Srini
              // Step 1: Parse dates into sortable format
              responseData.forEach(dateObj => {
                let parts = dateObj.Punch_timetoview.split(' ');
                let dateParts = parts[0].split('-');
                let timeParts = parts[1].split(':');

                // Create a sortable date format: YYYY-MM-DDTHH:mm:ss
                dateObj.sortableDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0], timeParts[0], timeParts[1], timeParts[2]);
              });

              // Step 2: Sort dates in descending order
              setRecentWithdrawalsData(responseData.sort((a, b) => b.sortableDate - a.sortableDate));
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  };
  // start, fin yr dates, srini - 30-01-25
  const setFromDateToDate = async () => {
    const currentYear = selectedYear.Database_Year

    let financialYearStart, financialYearEnd;
    let aa = 0
    aa = parseInt(currentYear) + 1
    financialYearStart = "01/04/" + currentYear
    financialYearEnd = "31/03/" + aa

    let fd = financialYearStart.split("/").reverse().join("-");
    let td = financialYearEnd.split("/").reverse().join("-");

    setFromDate(fd);
    setToDate(td);
    fromDateRef.current = financialYearStart;
    toDateRef.current = financialYearEnd;

    fetchTxList()
  };

  useEffect(() => {
    setFromDateToDate()
  }, [submitdata, selectedYear.Database_Year])
 // end - srini - 30-01-25 
  return <RecentWithdrawalsList
    data={recentWithdrawalsData}
    showlodder={showlodder}
    handleCancelClick={handleCancelClick}
    getStatus={getStatus}
    withdrawcancel={withdrawcancel}
    cuserrefno={cuserrefno}
    camount={camount}

  />;
};

export default RecentWithdrawalsListController;
